import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar-item-container" }
const _hoisted_2 = { class: "sidebar-item-content" }

import SvgLoader from '@/utils/SvgLoader.vue';
import { RouterItem } from './interfaces/routerItems';
import { i18n } from '@/i18n';
import Mdi from '@/corePagesModule/components/Mdi.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBarItem',
  props: {
    routeItem: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      "data-testid": _ctx.routeItem.to == '/translate-excel' ? `sidebar-content_inventory_information` : '',
      to: _ctx.routeItem.to
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.routeItem.icon)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.routeItem.icon.startsWith('sidebar-logo'))
                  ? (_openBlock(), _createBlock(SvgLoader, {
                      key: 0,
                      class: "sidebar-item-content__icon-image",
                      name: _ctx.routeItem.icon
                    }, null, 8, ["name"]))
                  : (_openBlock(), _createBlock(Mdi, {
                      key: 1,
                      class: "sidebar-item-content__icon-image",
                      icon: _ctx.routeItem.icon,
                      tag: "div"
                    }, null, 8, ["icon"]))
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_i18n_t, {
            class: "sidebar-item-content__label-text i18n-break",
            keypath: _ctx.routeItem.name,
            tag: "p"
          }, {
            newLine: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          }, 8, ["keypath"])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["data-testid", "to"])
  ]))
}
}

})